<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>游览路线管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 80%;margin-left: 10%;margin-right: 10%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="id" label="id" width="300">
      </el-table-column>
      <el-table-column prop="lineName" label="名称" width="300">
      </el-table-column>
      <el-table-column prop="lineTime" label="预计游览时间（小时）" width="300">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleQuery(scope.$index, scope.row)">查看详情</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="路线名称" prop="lineName">
          <el-input size="small" v-model="editForm.lineName" auto-complete="off" placeholder="请输入景点名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="路线" prop="linePay">
          <el-input size="small" v-model="editForm.linePay" auto-complete="off" placeholder="请输入景点地址"></el-input>
        </el-form-item> -->
        <el-form-item label="预计游览时间" prop="lineTime">
          <el-input size="small" v-model="editForm.lineTime" auto-complete="off" placeholder="请输入环境描述"></el-input>
        </el-form-item>
        <el-form-item label="路线列表" prop="lineName">
          <div v-for="(scDetail, index) in editForm.sightsDetailList">
            <el-select v-model="scDetail.id" placeholder="请选择" style="margin-bottom: 10px;">
              <el-option v-for="item in scOptions" :key="item.id" :label="item.sightsName" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="warning"
              @click.prevent="removeScDetail(editForm.sightsDetailList, scDetail)">移除景点</el-button><br />
          </div>
        </el-form-item>
        <el-form-item label="" prop="lineName">
          <el-button type="primary" @click="addScDetails(editForm.sightsDetailList)">添加路线景点</el-button>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 查看界面 -->
    <el-dialog :title="title" :visible.sync="queryFormVisible" width="50%" @click="closeDialog" disabled="true">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" disabled="true">
        <el-form-item label="路线名称" prop="lineName">
          <el-input size="small" v-model="editForm.lineName" auto-complete="off" placeholder="请输入景点名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="路线" prop="linePay">
          <el-input size="small" v-model="editForm.linePay" auto-complete="off" placeholder="请输入景点地址"></el-input>
        </el-form-item> -->
        <el-form-item label="预计游览时间" prop="lineTime">
          <el-input size="small" v-model="editForm.lineTime" auto-complete="off" placeholder="请输入环境描述"></el-input>
        </el-form-item>
        <el-form-item label="路线列表" prop="lineName">
          <div v-for="(scDetail, index) in editForm.sightsDetailList">
            <el-select v-model="scDetail.id" placeholder="请选择" style="margin-bottom: 10px;">
              <el-option v-for="item in scOptions" :key="item.id" :label="item.sightsName" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { campListAudit } from '../../api/campsMG'
import { deleteById, lineList, lineSave, lineScDetails } from '../../api/linesMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      auditFormVisible: false, //控制编辑页面显示与隐藏
      queryFormVisible: false, //查看页面显示与隐藏
      title: '添加',
      editForm: {
        id: '',
        lineName: '',
        linePay: '',
        lineTime: '',
        sightsDetailList: []
        // token: localStorage.getItem('logintoken')
      },
      auditForm: {
        id: '',
        status: ''
      },
      // rules表单验证
      rules: {
        lineName: [
          { required: true, message: '请输入路线名称', trigger: 'blur' }
        ],
        lineTime: [{ required: true, message: '请输入路线游玩时间', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      scOptions: [],
      selectValues: [

      ]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      lineList(this.pageparm)
        .then(res => {
          this.loading = false
          if (res.data.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    removeScDetail(arr, item) {
      console.log("remove" + arr + ":" + item);
      var index = arr.indexOf(item)
      if (index !== -1) {
        arr.splice(index, 1)
      }
    },
    addScDetails(arr) {
      arr.push({});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示审核界面
    handleAudit: function (index, row) {
      this.auditFormVisible = true
      this.title = '审核'
      this.auditForm.id = row.id
      this.auditForm.status = (row.status).toString()
    },
    // 审核页面保存方法
    submitAuditForm(editData) {
      // console.log(this.editForm);
      // this.auditForm.status = parseInt(this.auditForm.status);
      campListAudit(this.auditForm)
        .then(res => {
          // console.log(res);
          this.auditFormVisible = false
          this.loading = false
          if (res.data.code == 200) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '审核成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('审核失败，请稍后再试！')
        })
    },
    handleQuery: function (index, row) {
      lineScDetails().then(res => {
        this.loading = false
        if (res.data.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.scOptions = res.data.data
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('景点选项加载失败，请稍后再试！')
      });
      this.queryFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '查看'
        this.editForm.id = row.id
        this.editForm.lineName = row.lineName
        this.editForm.linePay = row.linePay
        this.editForm.lineTime = row.lineTime
        const originalArray = row.sightsDetailList;
        this.editForm.sightsDetailList = JSON.parse(JSON.stringify(originalArray));
      }
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      lineScDetails().then(res => {
        this.loading = false
        if (res.data.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.scOptions = res.data.data
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('景点选项加载失败，请稍后再试！')
      });
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.lineName = row.lineName
        this.editForm.linePay = row.linePay
        this.editForm.lineTime = row.lineTime
        const originalArray = row.sightsDetailList;
        this.editForm.sightsDetailList = JSON.parse(JSON.stringify(originalArray));
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.lineName = ''
        this.editForm.linePay = ''
        this.editForm.lineTime = ''
        this.editForm.sightsDetailList = []
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(JSON.stringify(this.editForm));
          lineSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              console.log(res);
              if (res.data.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteById({ id: row.id })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.auditFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/lines/lines.vue